import styled from "styled-components";
import { ModalFooter } from "reactstrap";

export const StyledFooter = styled(ModalFooter)`
  border-top: none;
`;
